import { Flex } from "@radix-ui/themes";
import { t } from "i18next";
import React from "react";
import { TbX } from "react-icons/tb";
import { Button } from "../../../ui/Button";
import { Popover, PopoverContent, PopoverTrigger } from "../../../ui/Popover";
import { useFormContext, Controller } from "react-hook-form";
import MultipleSelector from "../../../ui/MultipleSelector/MultipleSelector";
import { Calendar } from "../../../ui/Calendar";
import { DateTime } from "luxon";
import { DateRange } from "react-day-picker";

type Props = {
  usersList: { value: string; label: string }[];
  actionsList: { value: string; label: string }[];
  onSubmit: any;
};

const LogsFilters = ({ usersList, actionsList, onSubmit }: Props) => {
  const { handleSubmit, control, watch, reset } = useFormContext();

  function handleSelectDate(v: DateRange | undefined, onChange: (...event: any[]) => void) {
    onChange(v);
  }

  const cleanFilter = (e: React.MouseEvent<SVGElement, MouseEvent>) => {
    e.stopPropagation();
    reset();
    handleSubmit(onSubmit)();
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <div className="flex flex-none items-center">
          <Button type="button" variant="outline" size="xs" className="px-0 items-center">
            <span className="px-2">{t("filters")}</span>
            <span className="border-l w-6 bg-muted h-full p-0.5 flex items-center justify-center hover:bg-destructive hover:text-white rounded-r-md">
              <TbX className="cursor-pointer" onClick={(e) => cleanFilter(e)} />
            </span>
          </Button>
        </div>
      </PopoverTrigger>
      <PopoverContent style={{ width: 640 }} align={"start"}>
        <Flex direction={"column"} gap="3">
          <form onSubmit={handleSubmit(onSubmit)} className="w-full h-full max-w-min mx-auto">
            <Controller
              name="dates"
              control={control}
              render={({ field: { value, onChange } }) => {
                return (
                  <Calendar
                    mode="range"
                    defaultMonth={DateTime.local().minus({ month: 1 }).toJSDate()}
                    selected={value}
                    onSelect={(v) => handleSelectDate(v, onChange)}
                    numberOfMonths={2}
                    disabled={{
                      after: DateTime.local().toJSDate(),
                    }}
                  />
                );
              }}
            />
            <Controller
              name="users"
              control={control}
              render={({ field }) => (
                <MultipleSelector value={field.value} onChange={field.onChange} defaultOptions={usersList} />
              )}
            />
            <Controller
              name="actions"
              control={control}
              render={({ field }) => (
                <MultipleSelector value={field.value} onChange={field.onChange} defaultOptions={actionsList} />
              )}
            />
            <Button type="submit">Отфильтровать</Button>
          </form>
        </Flex>
      </PopoverContent>
    </Popover>
  );
};

export default LogsFilters;
